import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { ToolTip, Div, H2 } from '@driftt/tide-core';
import { Table } from '@driftt/tide-table'
import { CHART_NO_DATA_TEXT, clickColumns } from 'constants/ReportConstants'
import GraphContainer from 'components/Reports/EmailPerformance/Graphs'
import classnames from 'classnames'
import RowFormatter from 'components/Reports/EmailPerformance/TableRowFormatter'
import { EmptyGraphAndPage } from 'components/Reports/EmailPerformance/EmptyState'
import { roundPercentValue } from 'components/Reports/EmailPerformance/utils'
import { get } from 'lodash'

class CampaignTotalClicks extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeSection: 'CLICKED',
      currentData: null
    }
  }

  getClassNames(activeSection) {
    const defaultClass = 'reports-data-callout-item'
    return {
      sends: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'SENT'
      }),
      opens: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'OPENED'
      }),
      delivery: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'DELIVERED'
      }),
      clicks: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'CLICKED'
      }),
    }
  }

  componentDidMount() {
    this.setState({
      currentData: this.generateGraphData()
    })
  }

  changeGraphData(section) {
    this.setState({
      activeSection: section,
      currentData: this.generateGraphData(section)
    })
  }

  generateGraphData(section) {
    const { activeSection } = this.state
    const { data } = this.props
    const subField = section || activeSection
    const currentGraphData = []
    const previousGraphData = []

    const rawCurrentDates = data.byDate.current
    const rawPreviousDates = data.byDate.previous

    rawCurrentDates.forEach((date, i) => {
      const obj = [
        moment.utc(date.date).valueOf(),
        date.metrics[subField].value
      ]
      currentGraphData.push(obj)
    })

    rawPreviousDates.forEach((date, i) => {
      if (currentGraphData[i] === undefined)
        return

      let y = 0
      if (date.metrics.hasOwnProperty(subField)) {
        y = date.metrics[subField].value
      }

      const obj = [
        currentGraphData[i][0],
        y
      ]
      previousGraphData.push(obj)
    })

    return {
      current: currentGraphData,
      previous: previousGraphData
    }
  }

  generateTableRow = (email, index) => {
    const { data } = this.props
    const emailCampaignReport =  data.byEmail.find((mail) => mail.emailInCampaignId === email.id)
    return (
      RowFormatter.ClickRows(emailCampaignReport, email.subjectLine, index)
    )
  }

  renderTable() {
    const { data, campaign } = this.props
    const emails = campaign.emails
    const rows = !data ? []: emails.map(this.generateTableRow)
    return <Table columns={clickColumns} className="email-reports-table" data={rows} />
  }

  renderCalloutHeader(className, value, changeToGraph, title, tooltipComponent, conversionRate) {
    return (
      <ToolTip component={tooltipComponent} flow="up">
        <Div className={className} onClick={() => this.changeGraphData(changeToGraph)}>
          <Div className="callout-header">{title}</Div>
          <Div className="callout-large">{value}</Div>
          <Div className="callout-subtext">{conversionRate}</Div>
        </Div>
      </ToolTip>
    )
  }

  render() {
    const { activeState, data } = this.props
    const { activeSection, currentData } = this.state
    const { sends, delivery, opens, clicks } = this.getClassNames(activeSection)

    const total = data.total
    const baseValue = total.DELIVERED.value

    const deliveredValue = get(total, 'DELIVERED.value', 0)
    const sentValue = get(total, 'SENT.value', 0)
    const openedValue = get(total, 'OPENED.value', 0)
    const clickedValue = get(total, 'CLICKED.value', 0)
    const conversationValue = get(total, 'CONVERSATION_INFLUENCED.value', 0)

    const deliveredPercent = roundPercentValue(deliveredValue, sentValue)
    const clickPercent = roundPercentValue(clickedValue, baseValue)

    const hasDisplayData = (
      (deliveredValue !== 0 && deliveredValue !== undefined) ||
      (sentValue !== 0 && sentValue !== undefined) ||
      (openedValue !== 0 && openedValue !== undefined) ||
      (clickedValue !== 0 && clickedValue !== undefined) ||
      (conversationValue !== 0 && conversationValue !== undefined)
    )

    return (
      <Div className="email-performance-breakdown email-performance-breakdown--clicks">
        {hasDisplayData ?
          <Div className="reports-data-callout">
            {this.renderCalloutHeader(
              sends,
              sentValue,
              'SENT',
              'Sent',
              <Div className="metric-tooltip-center">
                Total amount of sent emails<br /> in this campaign.
              </Div>,
            )}
            {this.renderCalloutHeader(
                delivery,
                deliveredValue,
                'DELIVERED',
                'Delivered',
                <Div className="metric-tooltip-center">
                  Total amount of delivered<br />emails in this campaign.
                </Div>,
                `(${deliveredPercent}%)`,
              )
            }
            {this.renderCalloutHeader(
              opens,
              openedValue,
              'OPENED',
              'Opens',
              <Div className="metric-tooltip-center">
                Total amount of unique<br />opens in this campaign.
              </Div>,
            )}
            {this.renderCalloutHeader(
              clicks,
              clickedValue,
              'CLICKED',
              'Clicks',
              <Div className="metric-tooltip-center">
                Total unique clicks<br />in this campaign.
              </Div>,
              `(${clickPercent}%)`,
            )}
          </Div> :
          <Fragment>
            <Div className="reports-graph-data-overlay">
              <EmptyGraphAndPage />
              <H2>{CHART_NO_DATA_TEXT}</H2>
            </Div>
          </Fragment>
        }
        <Div className="reports-graph-container">
          {!!currentData &&
            <GraphContainer activeTab={activeState} graphData={currentData}/>
          }
        </Div>
        <Div className="reports-table-container">
          {this.renderTable()}
        </Div>
      </Div>
    )
  }
}

const mapStateToProps = state => ({
  orgUsers: state.org.users,
})

export default connect(mapStateToProps)(CampaignTotalClicks)
